import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles({
  fullWidth: {
    width: '100%',
  },
  multiselectTitle: {
    margin: '0 !important',
    padding: '0 !important',
    fontSize: '12px !important',
  },
  iconUploadContainer: {
    height: '100%',
    minHeight: '40px',
    display: 'flex',
    alignItems: 'center',
  },
  iconUploadPreviewContainer: {
    textAlign: 'center',
    border: '1px dashed #ccc',
    margin: '0 20px',
    height: '70px',
    width: '70px',
    minHeight: '35px',
    minWidth: '35px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  iconPreview: { maxWidth: 50, maxHeight: '100%' },
  imageUploadContainer: {
    height: '250px',
    display: 'flex',
    alignItems: 'center',
  },
  imageUploadPreviewContainer: {
    height: '100%',
    flex: 1,
    margin: '10px',
    border: '1px dashed #ccc',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  imagePreview: { maxWidth: 300, maxHeight: 'calc(100% - 20px)' },
  checkbox: {
    padding: '0px !important',
    margin: '0px !important',
  },
})

export { useStyles }
